module.exports = __webpack_public_path__ + "static/media/ricardo-perez-minus.a8e2a39c.svg";